module.exports = __webpack_public_path__ + "img/21.86e46429.jpg";